// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-jhs-free-entry-duplicate .m-heading-plain[data-v-c5eba307]{font-size:1rem;padding-bottom:1px}.c-jhs-free-entry-duplicate .is-mgl4[data-v-c5eba307]{margin-left:4px !important}", ""]);
// Exports
module.exports = exports;
